import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const LanguageArtsLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_7_"
        x1="427.88"
        x2="491.433"
        y1="66.614"
        y2="66.614"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="10.91"
        y="21.49"
        width="67.76"
        height="67.4"
        rx="15.68"
        transform="translate(-10.25 10.22) rotate(-11.69)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_7_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(14 35) rotate(-12.23)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_6_"
        x1="487.929"
        x2="555.452"
        y1="108.183"
        y2="108.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="90.35"
        y="10.13"
        width="66.77"
        height="66.41"
        rx="15.68"
        transform="translate(-1.27 4.25) rotate(-1.96)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_6_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(97 18) rotate(-1.96)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_5_"
        x1="564.252"
        x2="639.061"
        y1="130.613"
        y2="130.613"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="178.62"
        y="16"
        width="66.22"
        height="65.88"
        rx="15.68"
        transform="translate(11.99 -40.5) rotate(11.24)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_5_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(191 18.25) rotate(11.24)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_8_"
        x1="478.175"
        x2="548.883"
        y1="227.51"
        y2="227.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="33.52"
        y="92.09"
        width="66.14"
        height="65.79"
        rx="15.68"
        transform="translate(-23.65 18.92) rotate(-11.69)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_8_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(36 108) rotate(-11.69)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_3_"
        x1="549.091"
        x2="619.798"
        y1="218.327"
        y2="218.327"
        gradientTransform="rotate(16.219 592.677 222.333)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="125.57"
        y="86.51"
        width="65.22"
        height="64.88"
        rx="15.68"
        transform="translate(0.74 -1) rotate(0.35)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_3_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(132.5, 92.5) rotate(0.35)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_4_"
        x1="629.318"
        x2="691.327"
        y1="232.946"
        y2="232.946"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="218.71"
        y="89.27"
        width="65.22"
        height="64.88"
        rx="15.68"
        transform="translate(0.76 -1.49) rotate(0.35)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_4_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(225.5, 95.5) rotate(0.35)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g
      className="digital-resources-language-art"
      transform="translate(520, 170)"
    >
      <g id="f6a32fb3-2f4c-4c3d-896e-14408f6fd43b">
        <g>
          <path
            d="M503.93,607.14H399.37l-.69.85c.23-.28.46-.56.68-.85H277.44c.44-4.15.85-8.44,1.23-12.83q.46-5.37.85-11a609.72,609.72,0,0,0,.46-80.75l-.18-2.74q-.63-9.12-1.6-18.36c-.87-8.29-2-16.65-3.32-25-.45-2.89-.95-5.79-1.47-8.68-.5-2.72-1-5.45-1.57-8.17h0c-2.35-11.65-5.23-23.27-8.7-34.76q-2.47-8.22-5.39-16.33c-.12-.35-.25-.71-.38-1.06q-5.1-14.12-11.59-27.75a270.62,270.62,0,0,0-17-30.4q-3.87-6-8.14-11.83A237.48,237.48,0,0,0,197,289.75q-5.65-5.69-11.81-11.06-2.32-2-4.72-4c-.8-.66-1.6-1.32-2.41-2-1.61-1.31-3.25-2.6-4.91-3.85q-5.59-4.29-11.57-8.3a.27.27,0,0,0-.1-.06q-3.93-2.65-8-5.18-4.89-3-10-5.84l-1.14-.63-1-.54-1.14-.62-.58-.31c-29.49-15.64-64.83-27-107.07-32.42,26.88.37,52,.56,75.35.59h8.79c25.39,0,48.73-.19,70.2-.54q7.37-.12,14.43-.26l2.14,0c21.47-.44,40.92-1,58.55-1.76h0q8-.33,15.57-.69l9.58-.48,5.31-.29c23.15-1.27,42.47-2.78,58.58-4.37,15.13-1.5,27.43-3.08,37.43-4.64,36.77-5.73,42.29-11.19,42.29-11.19s.31,4.58,1,12.86c.56,7.15,1.38,17.07,2.47,29.17.05.47.09,1,.13,1.43.39,4.17.8,8.6,1.25,13.25h0c.09,1,.19,2,.29,3h0l.06.56c0,.25,0,.51.07.76l.18,1.87c.17,1.73.35,3.49.53,5.28.07.73.14,1.47.22,2.22.11,1.11.23,2.23.34,3.37,0,.37.07.75.11,1.14h0c1.7,16.5,3.74,35,6.17,54.87q1,7.88,2,16,1.32,10.41,2.8,21.19c1.49,10.86,3.08,21.95,4.78,33.18,2.31,15.28,4.83,30.81,7.57,46.34,1.78,10.14,3.66,20.29,5.63,30.36q1.2,6.16,2.46,12.29,1.15,5.67,2.36,11.28c.08.39.17.78.25,1.17q.73,3.4,1.48,6.78C481.56,539.36,491.86,576.66,503.93,607.14Z"
            fill="#be279d"
          />
          <path
            d="M143.44,249.54l-6.71-9.21,294-10.14,3.43,3.17c.88,9.67,1.94,20.74,3.18,32.91-8.59,5.72-20,13.41-34,23.08-34.18,23.66-100.84,10.14-148.7-5.07a155.83,155.83,0,0,0-69.51-5.59A239.84,239.84,0,0,0,143.44,249.54Z"
            fill="#a02ca2"
          />
          <g>
            <path
              d="M526,175.76C454.78,151.9,179.68,76.13,0,191.07c27.22,31.92,95.86,80.47,177.53,67.7s147,57.47,245,0S564.1,188.53,526,175.76Z"
              fill="#b96fc6"
            />
            <path
              d="M0,191.07a167.5,167.5,0,0,0,13.8,13c4.8,4.09,9.8,7.94,14.94,11.56a232.59,232.59,0,0,0,32.35,19.19,212,212,0,0,0,34.83,13.61,188.2,188.2,0,0,0,36.47,7.13,180.42,180.42,0,0,0,37-.34c1.53-.16,3.05-.4,4.58-.59l4.61-.71c3.24-.51,6.5-.94,9.77-1.2a143.13,143.13,0,0,1,19.64-.35,224.92,224.92,0,0,1,38.4,5.66c12.51,2.84,24.77,6.19,37,9.29a339.79,339.79,0,0,0,36.6,7.57,166.37,166.37,0,0,0,36.75,1.26,141.22,141.22,0,0,0,35.86-7.69,179.48,179.48,0,0,0,17.07-7.08c2.8-1.32,5.55-2.73,8.29-4.19l4.08-2.25,4.15-2.33c11.08-6.2,22.17-12.36,33.4-18.26s22.46-11.78,33.7-17.59,22.53-11.57,33.28-18.05a81.35,81.35,0,0,0,7.72-5.27,28.5,28.5,0,0,0,3.38-3.09,9.47,9.47,0,0,0,2.25-3.67,4.28,4.28,0,0,0-.85-3.88,12.86,12.86,0,0,0-3.44-3,51.36,51.36,0,0,0-8.53-4.06,47.69,47.69,0,0,1,8.93,3.36A13.92,13.92,0,0,1,539.9,182a6.34,6.34,0,0,1,1.32,2.27,5.49,5.49,0,0,1,.14,2.7,10.78,10.78,0,0,1-2.33,4.55,30,30,0,0,1-3.39,3.55,82.66,82.66,0,0,1-7.57,6c-5.22,3.71-10.63,7.06-16.06,10.37s-10.89,6.52-16.36,9.73c-21.93,12.71-43.81,25.38-65.46,38.42l-4.05,2.45L422,264.52c-2.8,1.61-5.63,3.18-8.52,4.65a162,162,0,0,1-17.82,7.88,155.45,155.45,0,0,1-18.72,5.7A150.51,150.51,0,0,1,357.56,286a167.52,167.52,0,0,1-39-.84,328,328,0,0,1-37.8-7.61c-12.37-3.09-24.52-6.52-36.7-9.3-6.1-1.39-12.18-2.65-18.29-3.66a183.78,183.78,0,0,0-18.34-2.08,141.91,141.91,0,0,0-18.33,0c-3,.19-6.07.53-9.09.94l-4.79.64c-1.62.17-3.23.39-4.86.52a174.19,174.19,0,0,1-38.87-.61,194.6,194.6,0,0,1-37.71-8.72,218.45,218.45,0,0,1-35.16-15.69,224,224,0,0,1-31.7-21.52A172,172,0,0,1,0,191.07Z"
              fill="#e4b9ed"
            />
            <path
              d="M455,167.64c-49.1-19.86-255.3-74.41-379.2,21.26,18.78,26.58,82.6,58.47,138.92,47.84s101.36,47.83,168.94,0S481.29,178.27,455,167.64Z"
              fill="#dc9cd0"
            />
          </g>
          <g>
            <g opacity="0.25">
              <path
                d="M444.56,191.27s10.64-8.46,11.86-12.36,2.9-4,1.36-4.59c-4.58-1.83-3.42-7.45,6.87-4,12.84,4.32,11.74,9.59,2.12,8.12-2.35,1.6-3.16,2.67-4.37,3.54-.95.69,1.51,6-15.64,11.51Z"
                fill="#531063"
              />
              <ellipse
                cx="464.92"
                cy="174"
                rx="2.17"
                ry="7.56"
                transform="translate(152.27 559.59) rotate(-71.48)"
                fill="#531063"
              />
              <path
                d="M457.51,186.32c3.2-.41,5.5-1.56,7.66-2s4.52-2.39,6.81-3.22,9.69-2.78,6.9-8.76c-3.45-2.66.65-5.81,10-2.65s11,5.8,8.85,7.18c-1.41.91-1.83,4.42-11,5.22s-13.87,2.69-14.48,3.4-2.61,4.49-9.79,5.84-17,2.54-17,2.54Z"
                fill="#531063"
              />
              <ellipse
                cx="488.49"
                cy="173.19"
                rx="2.17"
                ry="7.56"
                transform="translate(169.13 581.39) rotate(-71.48)"
                fill="#531063"
              />
              <path
                d="M467.14,188.11c3.23-.53,8.48.47,12.26.66,1.71.09,4.09.5,6.56.74,3.87.39,7.18-.82,8.05-2.93,1-2.42,6.15-3.93,9.6-.31,3.24,3.41,5.35,7.59,2.09,9.75-1.74,1.16-4.77.43-6.73-.76a11.34,11.34,0,0,0-6.13-1.41,31.19,31.19,0,0,1-9.28-.86c-3.56-.79-14.24-1.33-24.23,1.64s-12.09,1.35-12.25.85a14.67,14.67,0,0,1-.32-2Z"
                fill="#531063"
              />
              <ellipse
                cx="501.28"
                cy="190.63"
                rx="3.09"
                ry="5.29"
                transform="translate(-10.13 352.14) rotate(-38.35)"
                fill="#531063"
              />
              <path
                d="M465.84,190.37a12.78,12.78,0,0,0,6.38-4.9c.61-.71,5.29-2.6,14.48-3.4,7.53-.66,9.24-3,10.05-4.45a20.36,20.36,0,0,1-9.15-.78c1.39,1.59,2,2.4-.66,3.32s-4-.45-11.42,3-6.68,6-11.55,6.53c-3.29.36-9.66,2.27-13.46,3.48,1.73-.24,3.74-.52,5.82-.84Z"
                fill="#531063"
                opacity="0.47"
              />
              <g>
                <path
                  d="M479,172.62a4.5,4.5,0,0,1-.41,4.79c2.43-1.59,6.17-1.44,6.17-1.44A21.33,21.33,0,0,1,479,172.62Z"
                  fill="#531063"
                  opacity="0.47"
                />
                <polygon
                  points="477.27 178.68 477.27 178.68 477.27 178.68 477.27 178.68"
                  fill="#531063"
                />
              </g>
              <path
                d="M459.33,194.63c10-3,20.67-2.43,24.23-1.64,5.19,1.44,12.31.47,15.09,1.74,0,0-3.06-2.65-3.46-4.38-.76,2-1.49,2.75-5.71,2.78s-5.52-.9-9.56-1.35a73.25,73.25,0,0,0-13.4.19c-2.94.34-12.5,3.41-14.74,3.46s-4.7,0-4.7,0l2.26.88C451.09,196.48,454.14,196.17,459.33,194.63Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M448.77,189.07c2.34-.62,2-3.25,5.25-5s2.67-3.42,4.13-5.43,2.13-1.65,3.86-2.22a12,12,0,0,1-3.63-1.53h0a17.85,17.85,0,0,0-2,4c-1.22,3.9-11.86,12.36-11.86,12.36C445.68,191.08,446.43,189.69,448.77,189.07Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M460,187.18a50,50,0,0,0,8.62-3c1.69-.77,9.53-3.93,9.12-4.69a6.35,6.35,0,0,0-.5-.74,15.64,15.64,0,0,1-3.91,1.91h0s-3.34,1.66-5.84,2.77a9.94,9.94,0,0,1-2.32.91l-.63.15c-2,.53-.87.79-3.75,1.17C459.57,186.37,457.88,187.53,460,187.18Z"
                fill="#531063"
              />
              <path
                d="M504.56,190.05c-1.23-2.32-3.55-4.08-5.37-4a2,2,0,0,0-1.92,1.76C499.67,186.41,503,188.7,504.56,190.05Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M489.92,171.4c-3.89-1.44-7.69-1.8-8.48-.81-.28.35-.13.82.33,1.35,1.15-2.42,12.26,1.8,13,2.09A16,16,0,0,0,489.92,171.4Z"
                fill="#531063"
                opacity="0.47"
              />
              <path
                d="M465.79,172.21l-.7-.42c-3.42-1.07-6.52-1.27-7.23-.39-.33.42-.05,1,.64,1.66.21-.06.71.22,1.76,1.25l.2.11C458.08,170.36,465.79,172.21,465.79,172.21Z"
                fill="#531063"
                opacity="0.47"
              />
            </g>
            <g>
              <path
                d="M442.74,194.58S436.18,180,432,176s-3.73-5.26-4.91-4.54c-3.53,2.15-9.71-3-2.53-8.32,9-6.61,14.76-1.76,10.09,4.54,1.14,3,2.14,4.46,2.77,6.05.51,1.26,7.44,3.41,8.58,20.81Z"
                fill="#64cc2b"
              />
              <ellipse
                cx="428.93"
                cy="165.77"
                rx="6.24"
                ry="2.96"
                transform="translate(-19.96 265.56) rotate(-33.66)"
                fill="#170"
              />
              <path
                d="M441,180.83c.51-2.77-.12-5.42,0-7.44s-1.38-5.29-1.63-7.69-.26-9.58-8.07-12c-4.16.64-6.56-4.91,0-9.7s10.11-4.07,11.06-1.37c.63,1.78,4.57,4.77,2.68,12.46s-1.14,12.74-.5,13.74,4.41,5.43,3.78,12-2.27,15-2.27,15Z"
                fill="#64cc2b"
              />
              <ellipse
                cx="435.24"
                cy="146.98"
                rx="6.24"
                ry="2.96"
                transform="translate(-8.49 265.9) rotate(-33.66)"
                fill="#170"
              />
              <path
                d="M446,174.78c.38-2.9,3.15-6.18,4.54-8.95.62-1.25,1.83-2.77,2.88-4.49a7,7,0,0,0-.94-8.43c-2.51-2.61-2.68-7.73,2.6-7.63,4.95.09,10.46,1.64,12,5.8.81,2.21-1,4-3,4.6a5.47,5.47,0,0,0-3.51,3.66,15,15,0,0,1-3.86,6.49c-2,2.14-5.93,10-5.55,19.92s-2.15,10.34-2.78,10.09-2.39-1.26-2.39-1.26Z"
                fill="#64cc2b"
              />
              <ellipse
                cx="459.45"
                cy="150.38"
                rx="2.96"
                ry="6.24"
                transform="translate(178.91 544.09) rotate(-72.65)"
                fill="#170"
              />
              <path
                d="M448.24,177.49a18.89,18.89,0,0,0-3.73-8.64c-.64-1-1.39-6,.5-13.74,1.55-6.3-.63-9.39-2.09-11.13a10,10,0,0,1-3.71,6.47c2.27.12,3.4.25,3.66,3s-1.77,2.78,0,11.1,4.91,9.71,4,13.87c-.59,2.8-.33,9.16-.09,13,.25-1.51.54-3.28.8-5.12Z"
                fill="#11366d"
                opacity="0.47"
              />
              <g>
                <path
                  d="M431.66,153.85a10.42,10.42,0,0,1,5.44,4,8.29,8.29,0,0,1,.22-5.85A13.82,13.82,0,0,1,431.66,153.85Z"
                  fill="#11366d"
                  opacity="0.47"
                />
                <polygon
                  points="438.17 159.8 438.17 159.8 438.17 159.8 438.17 159.8"
                  fill="#170"
                />
              </g>
              <path
                d="M451.19,185.75c-.38-10,3.53-17.78,5.55-19.92,3.27-2.9,4.32-9.13,6.67-10.3,0,0-4,.34-6.17-.67,2.14,2.14,2.74,3.24,1.48,6.52s-2.74,3.57-4.51,6.34a38.43,38.43,0,0,0-3.91,10.47c-.5,2.52.13,12.23-.5,14s-1.39,3.66-1.39,3.66l1.72-1.08C450.81,193.51,451.38,190.92,451.19,185.75Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M441.48,189.66c0-2.27-3.15-4-4.16-7.82s-3.15-4.66-5.05-7.31-1.26-2.9-1.38-4.67a6.64,6.64,0,0,1-2.9,1.63h0a40.48,40.48,0,0,0,4,4.54c4.16,3.91,10.72,18.54,10.72,18.54C442.87,193.57,441.48,191.93,441.48,189.66Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M442.74,179.57c.25-1.89-.5-7.06-.88-8.95s-1.64-10.34-2.65-10.59a9.85,9.85,0,0,0-1-.19,16,16,0,0,1,1,4.47h0s.91,3.84,1.42,6.61a8.37,8.37,0,0,1,.34,2.47c0,.18,0,.38,0,.61,0,1.93.66,1.27.2,3.77C441.67,179.28,442.49,181.46,442.74,179.57Z"
                fill="#86e04b"
              />
              <path
                d="M459.77,147.41c-3.07-.81-5.82-.36-6.28,1.11-.27.87.33,1.9,1.46,2.82C454,148.41,457.72,147.62,459.77,147.41Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M433.6,144.51c-2.87,1.91-4.46,4.57-3.56,5.93a2.08,2.08,0,0,0,1.68.77c-2.46-2.72,5.86-8.08,6.44-8.45A10.06,10.06,0,0,0,433.6,144.51Z"
                fill="#11366d"
                opacity="0.47"
              />
              <path
                d="M427.11,163.72l-.69.23c-2.3,1.82-3.49,4.06-2.68,5.28a2.31,2.31,0,0,0,2.12.76c0-.2.47-.38,2-.41l.2-.06C422.59,168.26,427.11,163.72,427.11,163.72Z"
                fill="#11366d"
                opacity="0.47"
              />
            </g>
            <path
              d="M453.83,154.88a4.74,4.74,0,0,1,.67,2.4,8.91,8.91,0,0,1-.28,2.52,16.08,16.08,0,0,1-2.06,4.56c-1.73,2.75-3.51,5.45-5.43,8.11a31.65,31.65,0,0,1,2-4.49c.75-1.45,1.58-2.86,2.43-4.24a21.58,21.58,0,0,0,2.18-4.21A7.93,7.93,0,0,0,453.83,154.88Z"
              fill="#86e04b"
            />
            <path
              d="M455.8,145.58c-.67.37-1.3.7-1.87,1.07a3.72,3.72,0,0,0-1.32,1.25,1.88,1.88,0,0,0,0,1.6c.09.31.26.61.39.94a8.29,8.29,0,0,1,.49,1,9.3,9.3,0,0,1-.95-.64,5.09,5.09,0,0,1-.76-.89,2.51,2.51,0,0,1-.16-2.56,3.46,3.46,0,0,1,1.95-1.51A4.9,4.9,0,0,1,455.8,145.58Z"
              fill="#86e04b"
            />
            <path
              d="M430.79,146.16c-.42.64-.82,1.23-1.16,1.83a3.78,3.78,0,0,0-.58,1.71,1.91,1.91,0,0,0,.71,1.44c.23.23.52.42.79.65s.6.39.9.64a7.35,7.35,0,0,1-1.14-.12,4.79,4.79,0,0,1-1.09-.44,2.49,2.49,0,0,1-1.34-2.18,3.5,3.5,0,0,1,1-2.25A5,5,0,0,1,430.79,146.16Z"
              fill="#86e04b"
            />
            <path
              d="M424.19,164.31a20.76,20.76,0,0,0-.91,2,4.11,4.11,0,0,0-.3,1.9,2.51,2.51,0,0,0,.86,1.57c.23.25.54.43.82.68s.62.41.93.66a8,8,0,0,1-1.18-.13,5.73,5.73,0,0,1-1.12-.48,2.91,2.91,0,0,1-1.47-2.15,3.72,3.72,0,0,1,.65-2.46A4.79,4.79,0,0,1,424.19,164.31Z"
              fill="#86e04b"
            />
          </g>
        </g>
        <g>
          <path
            d="M79.06,198.14s16,21,45,4C128.06,179.14,71.06,183.14,79.06,198.14Z"
            fill="#531063"
            opacity="0.47"
          />
          <path
            d="M110.08,198.4c0,3.76-6.89,6.81-15.39,6.81s-15.4-3.05-15.4-6.81c0-.78.06-3.06.06-3.06s8.6-3.75,15.34-3.75S110,195.28,110,195.28,110.08,197.58,110.08,198.4Z"
            fill="#98baf5"
          />
          <ellipse cx="94.69" cy="195.55" rx="15.39" ry="6.81" fill="#b0dff6" />
          <path
            d="M94.19,193.85c1.27,1.16,12.62-2.73,12.62-2.73s-4.25-1.58-5-1.77a44.47,44.47,0,0,0-8.88,2.73Z"
            fill="#90a3f4"
          />
          <path
            d="M94.89,194.56h-2.5v-171L94.67,0,97,23.58V192.47A2.09,2.09,0,0,1,94.89,194.56Z"
            fill="#b0dff6"
          />
          <path
            d="M94.67,0l-1,10.86,1.27,12.91V194.56h0A2.09,2.09,0,0,0,97,192.47V23.58Z"
            fill="#98baf5"
          />
          <rect
            x="58.13"
            y="49.53"
            width="72.54"
            height="3.93"
            rx="1.73"
            transform="translate(183.58 111.57) rotate(-174.65)"
            fill="#b0dff6"
          />
          <path
            d="M119.77,55.88s2.45,9.17-.66,28.2c-3,18.65-13.31,28.54-11.41,46.8,1.93,18.55,3,35,3,35l-30.82-25.5L60.14,162.08S46.86,136.55,48,118.71s10.66-26.64,16-46.42c2.7-10,1.47-21.61,1.47-21.61Z"
            fill="#b62fc2"
          />
          <path
            d="M119.76,51.88a2.67,2.67,0,0,0,0,4c-7.55-.67-18.55-1.69-18.55-1.69s-2.16-2.24.31-4C107.59,50.57,119.76,51.88,119.76,51.88Z"
            fill="#a62fbf"
          />
          <path
            d="M83.63,48.41a2.67,2.67,0,0,0,0,4c-7.55-.68-18.56-1.7-18.56-1.7s-2.15-2.24.32-4C71.46,47.09,83.63,48.41,83.63,48.41Z"
            fill="#a62fbf"
          />
          <path
            d="M92.39,23.58V35.19a4.64,4.64,0,0,0,2.86.61c.44,0,1.29-.25,1.73-.29V23.58L94.67,0Z"
            fill="#d2ddef"
          />
          <path
            d="M58.26,48.34l.05-.46a1.73,1.73,0,0,1,1.89-1.57l.14,0a.85.85,0,0,0,0,.23l0,.46a1.73,1.73,0,0,0,1.57,1.89l68.62,6.43a1.73,1.73,0,0,1-1.84,1.33L59.83,50.23A1.75,1.75,0,0,1,58.26,48.34Z"
            fill="#b0dff6"
            opacity="0.5"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M94.67,0l-.49,5.07L95.84,22l.22,12.34a15.78,15.78,0,0,1-1.93.06,8.47,8.47,0,0,1-1.74-.31v1.1a4.64,4.64,0,0,0,2.86.61c.44,0,1.29-.25,1.73-.29V23.58Z"
            fill="#bfd0ee"
          />
          <path
            d="M97.2,34.82c0,.58-1.12,1-2.5,1s-2.5-.47-2.5-1"
            fill="none"
            stroke="#d2ddef"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M63.94,72.29c-.65,2.43-1.37,4.68-2.12,6.82C74,79,94.23,84.13,104,84.94c13.7,1.14,18.83-23,15.78-29.06-5.94-.66-20.07-1.6-33.65-3.22l-20.71-2S66.64,62.29,63.94,72.29Z"
            fill="#a72fc2"
          />
          <path
            d="M60.14,162.08l19.78-21.69,30.82,25.5s-1.11-16.46-3-35a42.52,42.52,0,0,1-.22-5.45c-18,2.92-49,2.41-59.56-3.45C48.4,139.51,60.14,162.08,60.14,162.08Z"
            fill="#a72fc2"
          />
          <g>
            <path
              d="M71.47,104.16h-.06a.41.41,0,0,0-.16,0h-.36l-.66,0q.19-4.69.13-8.58t-.2-6.24c-.07-.81-.36-1.28-.86-1.44l-.5-.13c-.18,0-.39-.08-.63-.11a8.88,8.88,0,0,0-1.33-.09,11.84,11.84,0,0,0-1.47.09,2.43,2.43,0,0,0-1.58,1.27Q62,91.9,60,95.33c-.69,1.2-1.38,2.42-2.07,3.65s-1.24,2.25-1.85,3.39c-.54-.15-.92-.24-1.15-.28a1,1,0,0,0-.68.17,1.82,1.82,0,0,0-.6.84c-.18.43-.36.92-.53,1.47s-.36,1.17-.56,1.84,0,1.34.63,1.59c-.3.6-.59,1.18-.86,1.74s-.48,1.05-.66,1.45-.18.43-.22.53l-.1.27c-.19.64-.09,1.09.29,1.36a9.57,9.57,0,0,0,1.44.75,6.41,6.41,0,0,0,1.56.44c.58.08,1.05-.32,1.41-1.17.29-.66.58-1.33.89-2s.63-1.39,1-2.12c.6.14,1.21.26,1.84.37s1.27.21,1.91.29c1,.14,2,.24,3,.29l-.41,4.07a2.37,2.37,0,0,0,.08,1.06.68.68,0,0,0,.61.42,7.78,7.78,0,0,0,1.74,0,12,12,0,0,0,1.75-.35,1.44,1.44,0,0,0,1-1.14,1.54,1.54,0,0,0,.07-.29c0-.11,0-.33.09-.64s.09-.89.14-1.42.1-1.09.15-1.69a1.49,1.49,0,0,0,.44-.09,1.38,1.38,0,0,0,.33-.2,2.56,2.56,0,0,0,.61-1,4.7,4.7,0,0,0,.24-.65c.06-.22.12-.43.17-.63a12.82,12.82,0,0,0,.45-2.24C72.17,104.63,72,104.23,71.47,104.16Zm-8.66-.77-1.92-.27.51-1c.55-1.06,1.11-2.14,1.69-3.22.75-1.42,1.53-2.87,2.36-4.36,0,1.41,0,2.88,0,4.44s-.14,3.12-.25,4.7L63,103.42l-.2,0Z"
              fill="#8acdf2"
            />
            <path
              d="M91,93.74A4.1,4.1,0,0,0,89.83,92a7,7,0,0,0-2-1.2,11.67,11.67,0,0,0-2.52-.66A24.41,24.41,0,0,0,78,90a2.66,2.66,0,0,0-1,.33,2.35,2.35,0,0,0-.75,1.28c-.07.2-.13.38-.18.55s-.1.36-.15.56c-.13.44-.24.88-.34,1.33a13,13,0,0,0-.22,1.32c-.11.81.08,1.24.55,1.31a2.09,2.09,0,0,0,.78,0L76,99c-.3,1.06-.58,2.12-.86,3.17s-.55,2.12-.81,3.2-.53,2.2-.78,3.35-.5,2.35-.78,3.64v0a5.55,5.55,0,0,0-.14,2.52,1.71,1.71,0,0,0,.89,1,10,10,0,0,0,2,.7q1.13.26,2.07.39l.39,0a8.65,8.65,0,0,0,3.24-.32,10.24,10.24,0,0,0,3.24-1.61,11.18,11.18,0,0,0,2.56-2.66,10.84,10.84,0,0,0,1.58-3.43,7.66,7.66,0,0,0,.3-2.54,4.46,4.46,0,0,0-.56-2,4.17,4.17,0,0,0-1.24-1.37,6,6,0,0,0-1.76-.85,16.85,16.85,0,0,0,1.89-1.13,11.1,11.1,0,0,0,1.65-1.4,8.61,8.61,0,0,0,1.3-1.7,8.14,8.14,0,0,0,.85-2A3.87,3.87,0,0,0,91,93.74Zm-7.19,14.38a3.39,3.39,0,0,1-1.51,2.15,4,4,0,0,1-2.67.44,6.54,6.54,0,0,1-.8-.15,4.41,4.41,0,0,1-.85-.27l1.06-4.53a9.35,9.35,0,0,1,2.17.07,6.89,6.89,0,0,1,1.15.25,3.11,3.11,0,0,1,.91.46,1.59,1.59,0,0,1,.52.67A1.4,1.4,0,0,1,83.85,108.12Zm0-8.9a11.94,11.94,0,0,1-3.51,1.56c.2-.8.41-1.59.61-2.36s.42-1.58.65-2.39l1.15,0c.37,0,.73,0,1.06.1a4,4,0,0,1,2.3.91A8.24,8.24,0,0,1,83.81,99.22Z"
              fill="#f4da34"
            />
            <path
              d="M110.18,93.4a5.7,5.7,0,0,0-1.14-.91A3.05,3.05,0,0,0,108,92c-.39-.06-.74.21-1,.81l-.32.63a8.27,8.27,0,0,0-1.83-.5,7.55,7.55,0,0,0-4.2.6A13,13,0,0,0,97,96l-.39.37a17.88,17.88,0,0,0-1.7,1.93,22.35,22.35,0,0,0-1.71,2.62c-.28.49-.54,1-.78,1.51a25.74,25.74,0,0,0-1.61,4.42,17.58,17.58,0,0,0-.66,5.11,10.94,10.94,0,0,0,.84,4,7.18,7.18,0,0,0,1.43,2.12,6,6,0,0,0,.65.58,5.71,5.71,0,0,0,1.84,1,6.23,6.23,0,0,0,1.17.26,5.5,5.5,0,0,0,.92,0,6.29,6.29,0,0,0,.86,0,12.37,12.37,0,0,0,2-.39,13.58,13.58,0,0,0,2-.75,8.87,8.87,0,0,0,1.72-1,2,2,0,0,0,.58-.69,4,4,0,0,0,.34-.92,7.82,7.82,0,0,0,.25-1.92,6.46,6.46,0,0,0-.18-1.83c-.09-.42-.24-.65-.44-.67a1.1,1.1,0,0,0-.65.17,13.81,13.81,0,0,1-2.53,1,6.35,6.35,0,0,1-2.41.19,2.83,2.83,0,0,1-1.53-.67.18.18,0,0,1-.07,0,3.6,3.6,0,0,1-.94-1.5,6.13,6.13,0,0,1-.27-2.09,11.2,11.2,0,0,1,.37-2.48,13.1,13.1,0,0,1,.91-2.45,7.26,7.26,0,0,1,.44-.83,10.7,10.7,0,0,1,1.89-2.37,7.24,7.24,0,0,1,2.1-1.41,3.75,3.75,0,0,1,2-.31l.39.07a1.13,1.13,0,0,1,.32.11c-.31.71-.61,1.39-.88,2s-.48,1.17-.62,1.53-.2.54-.23.63a1.09,1.09,0,0,0-.07.24,2.37,2.37,0,0,0-.05.83,1,1,0,0,0,.39.77,4.08,4.08,0,0,0,.77.53,6.11,6.11,0,0,0,.71.33,1.28,1.28,0,0,0,.3.12l.17,0a.77.77,0,0,0,.65-.19,2.88,2.88,0,0,0,.56-.85c.34-.69.71-1.44,1.1-2.27s.78-1.67,1.17-2.53.78-1.71,1.14-2.55.69-1.61,1-2.35a4.74,4.74,0,0,0,.18-.53A1.37,1.37,0,0,0,110.18,93.4Z"
              fill="#b0f440"
            />
          </g>
        </g>
        <g className="text">
          <path
            d="M220,244l-.06-.44a1.22,1.22,0,0,0-.23-.59.76.76,0,0,0-.57-.17l-.53,0-.79,0h-.16q-.37,0-1.32.06l-2.08,0v-.86c0-.81,0-1.62.06-2.4s.06-1.42.12-2.11h0c0-.29.05-.58.08-.87q.16-1.69.39-3.21c0-.12,0-.25.05-.37a1.68,1.68,0,0,0,0-.29.85.85,0,0,0-.13-.44.58.58,0,0,0-.49-.26,9.5,9.5,0,0,0-1-.11l-1,0a1.16,1.16,0,0,0-.77.22,1.07,1.07,0,0,0-.29.66c-.16,1.29-.29,2.55-.38,3.81h0c0,.18,0,.35,0,.53v.09c0,.13,0,.25,0,.38-.09,1.28-.13,2.56-.13,3.83s0,2.4.11,3.57a.76.76,0,0,0,.24.54.94.94,0,0,0,.52.2c.55,0,1.08.07,1.61.08l1.58,0c.7,0,1.39,0,2.09-.06l2.18-.15a1.19,1.19,0,0,0,.61-.2.77.77,0,0,0,.25-.54,1.09,1.09,0,0,0,0-.18.45.45,0,0,0,0-.11,2.44,2.44,0,0,0,0-.28C220,244.34,220,244.19,220,244Z"
            fill="#fff"
          />
          <path
            d="M231,237.14a.14.14,0,0,0,0-.06.67.67,0,0,0-.14-.28.74.74,0,0,0-.28-.21,3.14,3.14,0,0,0-.4-.13,6.9,6.9,0,0,0-1-.21,6.53,6.53,0,0,0-.85-.08.49.49,0,0,0-.38.13.79.79,0,0,0-.15.48,4.21,4.21,0,0,0-1.68-.34,4.69,4.69,0,0,0-2,.45,5.67,5.67,0,0,0-.8.45,6.13,6.13,0,0,0-.93.77,6.38,6.38,0,0,0-1.22,1.82,5.51,5.51,0,0,0-.47,2.26,4.48,4.48,0,0,0,.27,1.58,3.58,3.58,0,0,0,.78,1.25,3.52,3.52,0,0,0,1.23.83,4.42,4.42,0,0,0,1.63.29,4.57,4.57,0,0,0,1.54-.26,5,5,0,0,0,1.35-.76,1.43,1.43,0,0,0,.11.62c.08.14.3.24.65.29l.29,0h.75a2.11,2.11,0,0,0,.38,0,1.06,1.06,0,0,0,.7-.3,1.56,1.56,0,0,0,.27-.78c.14-1.17.24-2.38.31-3.65s.09-2.46.09-3.59A2.72,2.72,0,0,0,231,237.14Zm-3.27,3.78c0,.51-.05,1-.08,1.48a3,3,0,0,1-.91.64,2.49,2.49,0,0,1-.95.2,1.66,1.66,0,0,1-1.22-.42,1.51,1.51,0,0,1-.43-1.14,2.33,2.33,0,0,1,.16-.82,2.76,2.76,0,0,1,.47-.81,2.45,2.45,0,0,1,.75-.64,2,2,0,0,1,1-.25,3,3,0,0,1,.69.07,3.47,3.47,0,0,1,.57.19Q227.8,240.16,227.77,240.92Z"
            fill="#fff"
          />
          <path
            d="M241.79,237.65a2.19,2.19,0,0,0-.77-.82l-.17-.09a2.74,2.74,0,0,0-.79-.27,5.16,5.16,0,0,0-.9-.09,5.48,5.48,0,0,0-1.62.25,3.61,3.61,0,0,0-.62.24h0a4.69,4.69,0,0,0-.86.5c0-.1,0-.19,0-.28a1.28,1.28,0,0,0,0-.19v0a.64.64,0,0,0-.09-.36.44.44,0,0,0-.38-.14l-.55,0-.65.05-.62.07a3.57,3.57,0,0,0-.54.09.54.54,0,0,0-.44.39s0,0,0,0a5.5,5.5,0,0,0-.08.69c0,.23,0,.46,0,.69v.68c0,1,0,2,.1,3s.14,2,.25,2.93a1.33,1.33,0,0,0,.23.69,1.05,1.05,0,0,0,.77.26l.29,0H235l.3,0a1.35,1.35,0,0,0,.8-.21.58.58,0,0,0,.2-.49,1.21,1.21,0,0,0,0-.19.88.88,0,0,0,0-.21c-.07-.8-.13-1.59-.18-2.39S236,240.83,236,240a4.65,4.65,0,0,1,1.08-.56,3.13,3.13,0,0,1,1-.18.61.61,0,0,1,.54.27,1.35,1.35,0,0,1,.18.74c0,.78,0,1.44,0,2s0,1-.08,1.33-.05.63-.07.84,0,.39,0,.53a.75.75,0,0,0,.61.83,7.37,7.37,0,0,0,.88.14c.31,0,.56.05.75.05s.54-.09.64-.27a2.08,2.08,0,0,0,.18-.6c.07-.56.14-1.12.2-1.69s.1-1.12.13-1.64.05-1,.07-1.48,0-.85,0-1.19A2.86,2.86,0,0,0,241.79,237.65Z"
            fill="#fff"
          />
          <path
            d="M253.17,238.94c0-.17,0-.33,0-.48h0c0-.29,0-.54,0-.76a2.48,2.48,0,0,0-.08-.55,1.2,1.2,0,0,0-.18-.34.78.78,0,0,0-.29-.21,2.35,2.35,0,0,0-.4-.13l-.4-.1h0l-.65-.11a7.42,7.42,0,0,0-.82-.08.45.45,0,0,0-.33.11.66.66,0,0,0-.09.15,1.44,1.44,0,0,0-.05.24,3.79,3.79,0,0,0-.69-.16l-.34,0h-.36a2.92,2.92,0,0,0-.51,0h0a4.68,4.68,0,0,0-1.44.39l-.25.13h0a6,6,0,0,0-1.48,1,5.8,5.8,0,0,0-1.23,1.76A5.16,5.16,0,0,0,243,242a4.08,4.08,0,0,0,.27,1.5,3.43,3.43,0,0,0,.77,1.22,3.62,3.62,0,0,0,1.22.81,4.44,4.44,0,0,0,1.64.29,4.52,4.52,0,0,0,2.86-1c0,.47-.08.92-.13,1.36s-.11.85-.17,1.24a15.62,15.62,0,0,1-1.79-.12,8.8,8.8,0,0,1-1.76-.43,1.47,1.47,0,0,0-.48-.11.4.4,0,0,0-.28.1,1.26,1.26,0,0,0-.23.32c-.11.25-.23.53-.34.84a2.43,2.43,0,0,0-.17.73.64.64,0,0,0,.18.47,1.7,1.7,0,0,0,.45.31,11.49,11.49,0,0,0,2.19.73,11.08,11.08,0,0,0,2.42.24,3.8,3.8,0,0,0,1.15-.17,3.6,3.6,0,0,0,.92-.46,2.71,2.71,0,0,0,.65-.66,2.08,2.08,0,0,0,.34-.8c.08-.48.16-1,.22-1.67s.12-1.3.16-2,.06-1.41.08-2.13,0-1.41,0-2.07S253.18,239.42,253.17,238.94Zm-3.25,2.18c0,.36,0,.73,0,1.11a2.71,2.71,0,0,1-1.82.76,1.7,1.7,0,0,1-1.21-.41,1.42,1.42,0,0,1-.44-1.09,2.22,2.22,0,0,1,.16-.79,2.67,2.67,0,0,1,.47-.79,2.48,2.48,0,0,1,.75-.6,2,2,0,0,1,1-.25,3.64,3.64,0,0,1,.6.05,2.44,2.44,0,0,1,.5.14Z"
            fill="#fff"
          />
          <path
            d="M263.89,241.26c0-.33,0-.66-.05-1-.06-1-.14-2-.25-2.94a.81.81,0,0,0-.31-.65,1.54,1.54,0,0,0-.81-.16,4.14,4.14,0,0,0-.58,0l-.54.11a1.77,1.77,0,0,0-.78.36.83.83,0,0,0-.2.59c0,.11,0,.32,0,.63s.07.69.1,1.12,0,.61.06,1l0,.5c0,.53,0,1.08,0,1.67a4.52,4.52,0,0,1-1.09.56,3.23,3.23,0,0,1-1,.18A.61.61,0,0,1,258,243a1.32,1.32,0,0,1-.18-.73c0-.49,0-1,.05-1.49s.05-.76.08-1.11c0-.09,0-.19,0-.28,0-.42.08-.79.11-1.12s.05-.55.05-.69A.84.84,0,0,0,258,237a.88.88,0,0,0-.46-.3,3.18,3.18,0,0,0-.59-.15,4.73,4.73,0,0,0-.65,0,1.91,1.91,0,0,0-.92.17.93.93,0,0,0-.39.72c-.06.47-.12,1-.16,1.43l0,.26c-.06.57-.11,1.11-.14,1.64s0,1-.07,1.47,0,.86,0,1.2a2.86,2.86,0,0,0,.31,1.45,2.35,2.35,0,0,0,.77.82,2.8,2.8,0,0,0,1,.36,6.11,6.11,0,0,0,.9.08,5.59,5.59,0,0,0,1.63-.24,5.4,5.4,0,0,0,1.48-.74,2,2,0,0,1,0,.26c0,.08,0,.15,0,.23,0,.39.23.59.69.59a6,6,0,0,0,1-.1,4.55,4.55,0,0,0,1.1-.3.66.66,0,0,0,.43-.42,3.77,3.77,0,0,0,.1-.72c0-.23,0-.46,0-.68v-.71C263.94,242.61,263.92,241.93,263.89,241.26Z"
            fill="#fff"
          />
          <path
            d="M275.32,237.14a.83.83,0,0,0-.16-.34.86.86,0,0,0-.29-.21,2.69,2.69,0,0,0-.4-.13,6.76,6.76,0,0,0-1-.21,6.66,6.66,0,0,0-.86-.08.51.51,0,0,0-.38.13.79.79,0,0,0-.15.48,4.16,4.16,0,0,0-1.67-.34,4.66,4.66,0,0,0-2,.45,5.49,5.49,0,0,0-1.73,1.22,6.21,6.21,0,0,0-1.23,1.82,5.27,5.27,0,0,0-.43,1.67,5.83,5.83,0,0,0,0,.59,4.72,4.72,0,0,0,.26,1.58,3.58,3.58,0,0,0,.78,1.25,3.47,3.47,0,0,0,1.24.83,4.39,4.39,0,0,0,1.63.29,4.61,4.61,0,0,0,1.54-.26,4.82,4.82,0,0,0,1.34-.76,1.28,1.28,0,0,0,.12.62c.07.14.29.24.64.29l.3,0h.75a2.22,2.22,0,0,0,.38,0,1,1,0,0,0,.69-.3,1.56,1.56,0,0,0,.28-.78l0-.29c.12-1.08.21-2.19.27-3.36s.09-2.46.09-3.59A2.81,2.81,0,0,0,275.32,237.14Zm-4.9,6.08-.31,0a1.68,1.68,0,0,1-1.23-.42.44.44,0,0,1-.09-.11,1.52,1.52,0,0,1-.34-1,2.36,2.36,0,0,1,.17-.82,2.73,2.73,0,0,1,.46-.81,2.45,2.45,0,0,1,.75-.64,2,2,0,0,1,1-.25,2.84,2.84,0,0,1,.68.07,3.47,3.47,0,0,1,.57.19q0,.74-.06,1.5c0,.51-.05,1-.07,1.48a3,3,0,0,1-.92.64,2.42,2.42,0,0,1-.62.18Z"
            fill="#fff"
          />
          <path
            d="M286.72,238.94c0-.49,0-.91-.06-1.25a2.48,2.48,0,0,0-.08-.55,1.2,1.2,0,0,0-.18-.34.86.86,0,0,0-.29-.21,2.69,2.69,0,0,0-.4-.13,8,8,0,0,0-1.06-.21,7.42,7.42,0,0,0-.82-.08.45.45,0,0,0-.33.11.65.65,0,0,0-.14.39,3.7,3.7,0,0,0-.7-.16,5.09,5.09,0,0,0-.69,0,4.79,4.79,0,0,0-2,.43,5.72,5.72,0,0,0-3,2.92,5.16,5.16,0,0,0-.47,2.17,4.08,4.08,0,0,0,.27,1.5,3.29,3.29,0,0,0,.77,1.22,3.62,3.62,0,0,0,1.22.81,4.42,4.42,0,0,0,1.63.29,4.55,4.55,0,0,0,2.87-1c0,.47-.08.92-.13,1.36s-.09.68-.13,1c0,.09,0,.17,0,.25a16,16,0,0,1-1.8-.12,8.72,8.72,0,0,1-1.75-.43,1.47,1.47,0,0,0-.48-.11.39.39,0,0,0-.28.1,1.26,1.26,0,0,0-.23.32c-.11.25-.23.53-.34.84a2.16,2.16,0,0,0-.17.73.64.64,0,0,0,.18.47,1.82,1.82,0,0,0,.44.31,11.81,11.81,0,0,0,2.2.73,11.08,11.08,0,0,0,2.42.24,3.85,3.85,0,0,0,1.15-.17,3.77,3.77,0,0,0,.92-.46,2.71,2.71,0,0,0,.65-.66,2.06,2.06,0,0,0,.33-.8,2,2,0,0,1,.05-.24c.07-.42.13-.9.18-1.43s.11-1.3.15-2,.07-1.41.09-2.13,0-1.41,0-2.07S286.73,239.42,286.72,238.94ZM281.63,243a1.75,1.75,0,0,1-1.22-.41,1.41,1.41,0,0,1-.43-1.09,2.22,2.22,0,0,1,.16-.79,2.86,2.86,0,0,1,.46-.79,2.76,2.76,0,0,1,.75-.6,2,2,0,0,1,1-.25,3.73,3.73,0,0,1,.6.05,2.44,2.44,0,0,1,.5.14v1.87c0,.36,0,.73,0,1.11A2.73,2.73,0,0,1,281.63,243Z"
            fill="#fff"
          />
          <path
            d="M297.3,239.48a4.4,4.4,0,0,0-2.22-2.58,3.91,3.91,0,0,0-1.39-.42,5.36,5.36,0,0,0-.82-.06,5,5,0,0,0-1.87.36,4.92,4.92,0,0,0-1.59,1,5,5,0,0,0-1.09,1.56,4.9,4.9,0,0,0-.41,2,4.72,4.72,0,0,0,.4,1.95,4.79,4.79,0,0,0,1.06,1.5,4.54,4.54,0,0,0,1.52,1l.36.13a4.9,4.9,0,0,0,1.43.21,7.72,7.72,0,0,0,2.33-.33,4.05,4.05,0,0,0,1.6-.88.88.88,0,0,0,.3-.65v-.18a.81.81,0,0,0,0-.2l-.09-.42a3.71,3.71,0,0,0-.12-.41,1.35,1.35,0,0,0-.16-.32.25.25,0,0,0-.22-.1,1.21,1.21,0,0,0-.4.13,5,5,0,0,1-1.22.41,5.26,5.26,0,0,1-1.15.14,3.2,3.2,0,0,1-1.27-.25l-.1-.05a2.76,2.76,0,0,1-.88-.65c.35,0,.71,0,1.08-.07l.51,0c.55-.06,1.08-.12,1.59-.2s1-.16,1.46-.26a10.68,10.68,0,0,0,1.16-.33.7.7,0,0,0,.38-.3,1,1,0,0,0,.09-.42A4.17,4.17,0,0,0,297.3,239.48Zm-4.44.83-.14,0-1.81.12a2,2,0,0,1,.78-1,2.08,2.08,0,0,1,1.24-.4l.23,0a1.93,1.93,0,0,1,.65.22,1.4,1.4,0,0,1,.65.79A10.57,10.57,0,0,1,292.86,240.31Z"
            fill="#fff"
          />
          <path
            d="M315.77,240.77a.65.65,0,0,0-.69-.55h-.16l-.26,0-.47,0c-.54-1.54-1.09-2.93-1.64-4.2-.29-.67-.56-1.26-.81-1.79s-.42-.9-.61-1.27a1.13,1.13,0,0,0-.91-.64c-.11,0-.24,0-.38,0h-.47a8.68,8.68,0,0,0-1,.06,8.23,8.23,0,0,0-1,.15,1.19,1.19,0,0,0-.85.74q-.24.59-.48,1.2c-.29.71-.59,1.46-.88,2.23-.46,1.2-.89,2.43-1.3,3.67-.4,0-.69-.06-.85-.06a.74.74,0,0,0-.44.13.62.62,0,0,0-.25.44,5.28,5.28,0,0,0-.06.74c0,.28,0,.58,0,.91a.69.69,0,0,0,0,.25.58.58,0,0,0,.26.32,1.24,1.24,0,0,0,.46.15l-.09.31-.15.58c-.07.28-.12.53-.16.73s0,.21-.05.26a.71.71,0,0,0,0,.14.61.61,0,0,0,.48.62,8.53,8.53,0,0,0,1.15.27,6.73,6.73,0,0,0,.93.1h.23a.68.68,0,0,0,.74-.64q.1-.5.21-1c.08-.35.16-.7.25-1.07l1.36.06,1.39,0c.74,0,1.46,0,2.18-.06l.54,2a1.11,1.11,0,0,0,.26.51.78.78,0,0,0,.51.16,7.12,7.12,0,0,0,1.23-.11,11.06,11.06,0,0,0,1.17-.27.58.58,0,0,0,.45-.61.76.76,0,0,0,0-.14,3,3,0,0,0-.06-.32l-.18-.69c-.07-.26-.15-.53-.24-.82a.92.92,0,0,0,.49-.19.88.88,0,0,0,.23-.54,1.24,1.24,0,0,0,0-.33v-.31A4.6,4.6,0,0,0,315.77,240.77Zm-6.82-.34h-1.56c.22-.72.45-1.46.69-2.2s.5-1.5.77-2.28q.48,1,.9,2.16c.28.76.53,1.53.78,2.3Z"
            fill="#fff"
          />
          <path
            d="M324.08,238.65a5.51,5.51,0,0,0-.11-1,2.58,2.58,0,0,0-.38-.89.92.92,0,0,0-.8-.42,3.45,3.45,0,0,0-1.41.29,4.24,4.24,0,0,0-1.19.76l0-.3c0-.1,0-.2,0-.27a.64.64,0,0,0-.1-.36.44.44,0,0,0-.38-.14l-.55,0-.64.05-.63.07a3.42,3.42,0,0,0-.53.09.56.56,0,0,0-.45.39,4.51,4.51,0,0,0-.08.73c0,.23,0,.46,0,.69v.68q0,1.48.09,3c.07,1,.15,2,.25,2.93a1.43,1.43,0,0,0,.24.69,1,1,0,0,0,.77.26l.28,0h.66l.29,0a1.41,1.41,0,0,0,.81-.21.6.6,0,0,0,.2-.49c0-.1,0-.31-.05-.62s-.07-.69-.1-1.15-.06-1-.09-1.6-.05-1.24-.05-1.93a5.57,5.57,0,0,1,.54-.39l.49-.27a4.16,4.16,0,0,1,.07.59c0,.22,0,.41,0,.55a1.19,1.19,0,0,0,.17.6.56.56,0,0,0,.5.27,1.92,1.92,0,0,0,.6-.14,5.73,5.73,0,0,0,.63-.28,2,2,0,0,0,.73-.61,1.3,1.3,0,0,0,.2-.7C324.1,239.3,324.09,239,324.08,238.65Z"
            fill="#fff"
          />
          <path
            d="M330.86,237.57a.85.85,0,0,0-.53-.24c-.23,0-.46-.06-.68-.08l-.65-.07c0-.23,0-.47,0-.73l0-.75c0-.24,0-.45,0-.62s0-.28,0-.35a1,1,0,0,0-.17-.63.72.72,0,0,0-.61-.22A9.84,9.84,0,0,0,327,234a2.21,2.21,0,0,0-.77.23.71.71,0,0,0-.35.4,2,2,0,0,0-.11.61c0,.28,0,.53,0,.78s0,.48,0,.72v.53a5.21,5.21,0,0,0-.6.08.76.76,0,0,0-.36.17.58.58,0,0,0-.19.3,2.39,2.39,0,0,0,0,.51c0,.1,0,.22,0,.36a3,3,0,0,0,0,.42.81.81,0,0,0,.21.58,1.24,1.24,0,0,0,.58.18l.5.06c.06.93.13,1.84.21,2.71s.19,1.76.32,2.66a1,1,0,0,0,.24.62.83.83,0,0,0,.54.16,8.75,8.75,0,0,0,1.44-.12.83.83,0,0,0,.54-.22.79.79,0,0,0,.14-.52c0-.12,0-.39,0-.79s0-.86-.07-1.37-.06-1-.09-1.58,0-1,0-1.44l.44,0a4.8,4.8,0,0,0,.56-.06,1.13,1.13,0,0,0,.61-.18.82.82,0,0,0,.27-.52c0-.18,0-.37.06-.58s0-.37,0-.5A.87.87,0,0,0,330.86,237.57Z"
            fill="#fff"
          />
          <path
            d="M336.41,239.68a.82.82,0,0,0,.49.22A6.29,6.29,0,0,0,338,240a.67.67,0,0,0,.52-.16,1.35,1.35,0,0,0,.23-.45,6.57,6.57,0,0,0,.18-.87,5.36,5.36,0,0,0,.09-.91.87.87,0,0,0-.16-.58,1,1,0,0,0-.47-.3,8.53,8.53,0,0,0-1.3-.32,9.51,9.51,0,0,0-1.39-.11,5.65,5.65,0,0,0-1.59.22,4.68,4.68,0,0,0-1.36.6,3.26,3.26,0,0,0-1,1,2.21,2.21,0,0,0-.37,1.25,2.35,2.35,0,0,0,.29,1.22,3,3,0,0,0,.73.85,4.07,4.07,0,0,0,.95.59l.95.42a6.34,6.34,0,0,1,.73.35c.2.12.3.24.3.38a.35.35,0,0,1-.27.36,2,2,0,0,1-.7.1,3.75,3.75,0,0,1-.68-.08,2.88,2.88,0,0,1-.75-.25,1.6,1.6,0,0,0-.49-.15c-.14,0-.27.14-.4.4a5.87,5.87,0,0,1-.24.56,4.62,4.62,0,0,0-.21.58,1.62,1.62,0,0,0-.06.4.67.67,0,0,0,.51.63,5.82,5.82,0,0,0,1.21.33,8.83,8.83,0,0,0,1.43.1,6.24,6.24,0,0,0,1.66-.2,4.24,4.24,0,0,0,1.33-.57,2.84,2.84,0,0,0,.88-.88,2.1,2.1,0,0,0,.33-1.16,2.26,2.26,0,0,0-.33-1.25,2.89,2.89,0,0,0-.81-.86,5.3,5.3,0,0,0-1.07-.59c-.38-.16-.73-.3-1.06-.42a7.74,7.74,0,0,1-.82-.35c-.21-.12-.32-.24-.32-.38a.47.47,0,0,1,.33-.46,2.26,2.26,0,0,1,.83-.13,2.88,2.88,0,0,1,.61.09v.14A1.1,1.1,0,0,0,336.41,239.68Z"
            fill="#fff"
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(120, 70)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default LanguageArtsLink;
